/**
 * Trigger: tr_incomes_update
 * Purpose: Update account balances when income details change
 * Table: incomes
 * Event: UPDATE OF account_id, currency_id, income_date, amount, exchange_rate
 */
export const TR_INCOMES_UPDATE = `
CREATE TRIGGER tr_incomes_update
UPDATE OF account_id, currency_id, income_date, amount, exchange_rate ON incomes
BEGIN
  UPDATE account_balances
  SET incomes_amount = incomes_amount - old.amount
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id;

  UPDATE account_daily_balances
  SET incomes_amount = incomes_amount - old.amount
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.income_date;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_id, new.income_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.income_date);

  UPDATE account_balances
  SET incomes_amount = incomes_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id;

  UPDATE account_daily_balances
  SET incomes_amount = incomes_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.income_date;

  INSERT OR IGNORE INTO exchange_rates (rate_date, rate, currency_id)
  SELECT new.income_date, new.exchange_rate, new.currency_id
  WHERE new.exchange_rate > 0;

  DELETE FROM account_daily_balances
  WHERE account_id = old.account_id
    AND currency_id = old.currency_id
    AND balance_date = old.income_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_daily_balances
  WHERE account_id = new.account_id
    AND account_id != old.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.income_date
    AND expenses_amount = 0
    AND incomes_amount = 0
    AND debtors_amount = 0
    AND creditors_amount = 0
    AND debtor_payments_amount = 0
    AND creditor_payments_amount = 0
    AND transfers_amount = 0
    AND exchanges_amount = 0
    AND initial_balance = 0;

  DELETE FROM account_activity_dates
  WHERE account_id = old.account_id
    AND activity_date = old.income_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_id = old.account_id
        AND balance_date = old.income_date
    );

  DELETE FROM account_activity_dates
  WHERE account_id = new.account_id
    AND account_id != old.account_id
    AND activity_date = new.income_date
    AND NOT EXISTS (
      SELECT 1 FROM account_daily_balances
      WHERE account_id = new.account_id
        AND balance_date = new.income_date
    );
END;
`;
